import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "modern-normalize"; // normalization styles
import App from "./components/App.jsx";
import "./index.css";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
